var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.79 14.7C19.67 15.45 18.1 15.73 16.65 15.54C17.03 14.72 17.23 13.81 17.24 12.85C17.24 11.85 17.02 10.9 16.6 10.07C18.08 9.87001 19.65 10.15 20.78 10.9C22.36 11.94 22.36 13.65 20.79 14.7Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.43999 7.77C6.50999 7.76 6.57999 7.76 6.64999 7.77C8.19999 7.72 9.42999 6.45 9.42999 4.89C9.42999 3.3 8.13999 2 6.53999 2C4.94999 2 3.64999 3.29 3.64999 4.89C3.65999 6.45 4.88999 7.72 6.43999 7.77Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.54999 12.85C6.54999 13.82 6.75999 14.74 7.13999 15.57C5.72999 15.72 4.26 15.42 3.18 14.71C1.6 13.66 1.6 11.95 3.18 10.9C4.25 10.18 5.75999 9.89 7.18 10.05C6.77 10.89 6.54999 11.84 6.54999 12.85Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 15.87C12.04 15.86 11.95 15.86 11.86 15.87C10.02 15.81 8.54999 14.3 8.54999 12.44C8.54999 10.54 10.08 9 11.99 9C13.89 9 15.43 10.54 15.43 12.44C15.43 14.3 13.97 15.81 12.12 15.87Z",
    fill: "#292D32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86999 17.94C7.35999 18.95 7.35999 20.61 8.86999 21.61C10.59 22.76 13.41 22.76 15.13 21.61C16.64 20.6 16.64 18.94 15.13 17.94C13.42 16.79 10.6 16.79 8.86999 17.94Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.6e845a7b9b4395f39c53f7a79cb9c966.svg";
export { ForwardRef as ReactComponent };